import { Helmet } from 'react-helmet-async'
import Landing from '../Esg/Landing'
import CTO from '../Esg/CTO'
const CERTIFICATIONS = [
  {
    title: "ISO 9001:2015 - Quality Management System",
    image: "/assets/images/certification/iso-9001.png",
    description: "Certified for maintaining Structured quality management processes and consistently delivering excellence to our clients."
  },
  {
    title: "Great Place to Work",
    image: "/assets/images/certification/great-place-to-work-india.png",
    description: "Recognized for creating an empowering, inclusive, and high-performing workplace for our employees."
  }
]

function Certification() {
  return (
    <>
      <Helmet>
        <title>ISO 9001:2015 Certified ESG & Sustainability Consulting | Nirantara</title>
        <meta name="description" content="Discover Nirantara's certifications, including ISO 9001:2015 and Great Place to Work, reflecting our commitment to quality, excellence, and a positive workplace culture in ESG consulting." />
        <meta name="keywords" content="ISO 9001:2015 certified company, ESG consulting certification, sustainability consulting accreditation, Great Place to Work certified, quality management ESG, certified ESG consulting firm" />
        <link rel="canonical" href="https://nirantara.solutions/certification" />
      </Helmet>
      <h1 className="sr-only">Committed to Excellence, Compliance, and Sustainability</h1>
      <Landing
        image={"/assets/images/certification/main-img.jpg"}
        text={"Certification"}
      />
      <section className="flex flex-col items-center w-full gap-10 sm:gap-0 px-[2rem] py-[2rem] sm:px-[5rem] md:px-[5rem] lg:px-[15rem] montserrat bg-[#FFF]">
        <div className="flex flex-col-reverse md:grid md:grid-cols-1">
          <div className="flex flex-col justify-between w-full py-0 mx-auto text-white md:py-10">
            <h2 className="text-left !leading-snug text-3xl sm:text-4xl font-extrabold text-[#000000] my-4 sm:mt-10">
              Committed to Excellence, Compliance, and Sustainability
            </h2>
            <p className="mb-4 text-[#000000] text-lg leading-10">
              We uphold the highest standards in quality and employee experience. Our certifications reflect our dedication to delivering excellence while fostering a great workplace culture.
            </p>
          </div>
        </div>
        <div className="grid w-full grid-cols-1 sm:grid-cols-2 md:grid-cols-2">
          {CERTIFICATIONS.map(({ title, image, description }, index) => (
            <div className="flex flex-col items-center justify-center w-full p-5" >
              <div className="flex justify-center items-center w-full p-3 mb-3 rounded-lg h-[150px]"
                style={{
                  boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.12)'
                }}>
                <img src={image} alt={title} className="max-w-full max-h-full object-contain" />
              </div>
              <p className="w-full mb-1 text-xl font-bold text-left whitespace-pre-wrap">{title}</p>
              <p className="w-full mb-1 text-base text-left">{description}</p>
            </div>
          ))}
        </div>
      </section>
      <CTO
        title={"Ready to Equip Your Team for ESG Excellence?"}
        description={
          "Empower your leaders and employees with the knowledge and skills to drive sustainable, responsible, and impactful business practices."
        }
        buttonText={"Start Your ESG Journey"}
      />
    </>
  )
}

export default Certification
